<div class="flex h-full w-full flex-col">
  @if (sidepanelService.loading()) {
    <app-spinner />
  }

  <app-header-dashboard canReturn />
  <div class="m-lg">
    <router-outlet></router-outlet>
  </div>
</div>
